import { render, staticRenderFns } from "./PublicConfig.vue?vue&type=template&id=263ad9d5&scoped=true&"
import script from "./PublicConfig.vue?vue&type=script&lang=js&"
export * from "./PublicConfig.vue?vue&type=script&lang=js&"
import style0 from "./PublicConfig.vue?vue&type=style&index=0&id=263ad9d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263ad9d5",
  null
  
)

export default component.exports